import { actionTypes } from "../../types";

const initialState = {
    loading: false,
    status: '',
    message: '',
    data: {}
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_CONFIG_PROPERTY_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.UPDATE_CONFIG_PROPERTY_SUCCESS:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
                data: action?.payload?.response
            }
        case actionTypes.UPDATE_CONFIG_PROPERTY_FAILURE:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
            }
        case actionTypes.UPDATE_CONFIG_PROPERTY_RESET:
            return {
                ...state,
                status: '',
                message: ''
            }
        case actionTypes.UPDATE_CONFIG_PROPERTY_RESET_ALL:
            return initialState
        default:
            return state;
    }
};
